{
    "Target1Label": "Cible 1 :",
    "Target1Placeholder": "15",
    "Target2Label": "Cible 2 :",
    "Target2Placeholder": "30",
    "Target3Label": "Cible 3 :",
    "Target3Placeholder": "60",
    "Target4Label": "Cible 4 :",
    "Target4Placeholder": "90",
    "Target5Label": "Cible 5 :",
    "Target5Placeholder": "120",
    "Target6Label": "Cible 6 :",
    "Target6Placeholder": "300",
    "TargetUnit": "s",
    "ResetanswertargetsButtonLabel": "Réinitialiser les objectifs de réponse",
    "ResetanswertargetsPrompt": "Êtes-vous sûr de vouloir réinitialiser les 6 paramètres de seuil de durée de réponse aux appels entrants à leurs valeurs par défaut ?",
    "ResetanswertargetsPromptButtonConfirmLabel": "Confirmer",
    "ResetanswertargetsPromptButtonCancelLabel": "Annuler",
    "AnswerPerformance_SectionHeader": "Réponse Performance",
    "AnswerPerformance_SectionPara": "Vous pouvez également ajuster spécifiquement le(s) seuil(s) de durée de réponse cible, qui sont utilisés par les sept variantes de statistiques de performance des réponses entrantes de style \"Réponse <= Xs\".",
    "NAME": "AnswerPerformance"
}